// @ts-nocheck

import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import { dismissUpdate, update } from '../../actions/clientUpdater';

import ClientUpdater from './ClientUpdater';
import selectClientUpdaterProps from './ClientUpdater.selector';

const ClientUpdaterContainer = () => {
  const dispatch = useDispatch();

  const selectedProps = useSelector(selectClientUpdaterProps);

  const onUpdate = useCallback(() => {
    dispatch(update());
  }, [dispatch]);

  const onCancel = useCallback(() => {
    dispatch(dismissUpdate());
  }, [dispatch]);

  const otherProps = useMemo(() => ({ onUpdate, onCancel }), [onUpdate, onCancel]);

  const enhancedProps = useMergeProps({ selectedProps, otherProps });

  return <ClientUpdater {...enhancedProps} />;
};

export default ClientUpdaterContainer;
